import { observer, inject } from "mobx-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../UI";
import { useTheme } from "styled-components";
import { ScrollDiv } from "./Common";
import RepairPagesItem from "./RepairPagesItem";
import { useLocation, useNavigate } from "react-router-dom";

const RepairPagesList = ({
  tenantsStore,
  userStore,
  repairPagesStore,
  repairPages,
  setSelectedRepairPage,
  selectedRepairPage,
  isMobile,
}) => {
  const { t } = useTranslation("applies");
  const theme = useTheme();
  const [repairPage, setRepairPage] = useState(selectedRepairPage);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setRepairPage(selectedRepairPage);
  }, [selectedRepairPage]);

  const handleRepairPageSelected = async (repairPage, isNavigate) => {
    let note = null;

    if (repairPage.REPAIRNAME) {
      const body = {
        MAINCUST: tenantsStore.selectedSiteSpace.CUST,
        MAINENV: tenantsStore.selectedSiteSpace?.DNAME,
        CUST: tenantsStore.selectedSiteSpace.CUST,
        DNAME: tenantsStore.selectedContract?.DNAME,
        ENV: tenantsStore.selectedContract?.DNAME,
        CONTNAME: tenantsStore.selectedContract?.CONTNAME,
        SPACENAME:
          tenantsStore.selectedContract?.SPACENAME ||
          tenantsStore.selectedSiteSpace?.SPACENAME ||
          location?.state?.SPACENAME,
        CONT: tenantsStore.selectedContract?.CONT,
        REPAIRNAME: repairPage.REPAIRNAME,
      };

      note = await repairPagesStore.getRepairPage(body);

      if (!!note?.EXAMINERUSERID) {
        const examinBody = {
          USERID: note.EXAMINERUSERID,
          CUST: userStore.userDetails.CUST,
          MAINENV: userStore.userDetails.MAINENV,
          ENV: tenantsStore.selectedContract?.DNAME,
          DNAME: tenantsStore.selectedContract?.DNAME,
        };
        const examiner = await repairPagesStore.getExaminUserData(examinBody);
        note["EXAMINERCALENDLYLINK"] =
          examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYLINK;
        note["ZCOB_CALENDLYEVISIT"] =
          examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYEVISIT;
        note["ZCOB_CALENDLYEFIX"] =
          examiner?.USERSCURENV_SUBFORM.ZCOB_CALENDLYEFIX;
      }
    } else {
      const body = {
        MAINCUST: tenantsStore.selectedSiteSpace.CUST,
        MAINENV: tenantsStore.selectedSiteSpace?.DNAME,
        CUST: tenantsStore.selectedSiteSpace.CUST,
        DNAME: tenantsStore.selectedContract?.DNAME,
        ENV: tenantsStore.selectedContract?.DNAME,
        CONTNAME: tenantsStore.selectedContract?.CONTNAME,
        CONT: tenantsStore.selectedContract?.CONT,
        CUSTNOTE: repairPage.CUSTNOTE,
      };
      note = await tenantsStore.getSaleContractNote(body);
    }
    setSelectedRepairPage(note);
    repairPagesStore.setSelectedRepairPage(note);

    setRepairPage(note);
    if (isNavigate) {
      navigate("/tenant/apply");
    }
  };

  useEffect(() => {
    if (repairPages.length < 1) return;
    const firstItem = repairPages[0];

    handleRepairPageSelected(firstItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repairPages]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
      }}
    >
      <div style={{ margin: isMobile && "10px 20px" }}>
        <Text.BB color={theme.color.gray90}>
          {t(
            repairPages?.filter(
              (msg) => msg.WASREADFLAG !== "Y" && msg.ZCOK_WASREADFLAG !== "Y"
            ).length === 1
              ? "new_message"
              : "new_messages",
            {
              num: repairPages?.filter(
                (msg) => msg.WASREADFLAG !== "Y" && msg.ZCOK_WASREADFLAG !== "Y"
              ).length,
            }
          )}
        </Text.BB>
        <Text.BR color={theme.color.gray90}> | </Text.BR>
        <Text.BR color={theme.color.gray90}>
          {t("total_messages", {
            num: repairPages?.length,
          })}
        </Text.BR>
      </div>
      <ScrollDiv
        maxHeight={isMobile ? "calc(100vh - 30px - 162px)" : "76vh"}
        minHeight={isMobile ? "unset" : "76vh"}
        style={{ paddingInlineEnd: 20 }}
      >
        {repairPages?.map((msg, index) => (
          <RepairPagesItem
            key={index}
            newMsg={msg.WASREADFLAG !== "Y" && msg.ZCOK_WASREADFLAG !== "Y"}
            selected={
              !!msg?.REPAIRNAME
                ? msg?.REPAIRNAME === repairPage?.REPAIRNAME
                : msg?.CUSTNOTE === repairPage?.CUSTNOTE
            }
            message={msg}
            handleMessageSelected={handleRepairPageSelected}
          />
        ))}
      </ScrollDiv>
    </div>
  );
};

export default inject(
  "tenantsStore",
  "repairPagesStore",
  "userStore"
)(observer(RepairPagesList));
